import { useEffect, useState } from "react";
import "./CreateFeedModel.css";
import CreatePostPermissions from "./CreatePostPermissions";

export default function CreateFeedModel({ open = true, onClose = () => { } }) {

    const [permission, setPermission] = useState("public");
    useEffect(() => {
        const onKey = (e) => e.key === "Escape" && onClose();
        document.addEventListener("keydown", onKey);
        return () => document.removeEventListener("keydown", onKey);
    }, [onClose]);

    if (!open) return null;

    return (
        <div className="cfm-overlay" onClick={onClose} aria-modal="true" role="dialog">
            <div className="cfm-modal" onClick={(e) => e.stopPropagation()}>
                <button className="cfm-close" onClick={onClose} aria-label="Close">
                    ✕
                </button>


                <div className="cfm-header">

                    <img
                        className="cfm-avatar"
                        src="https://i.pravatar.cc/80?img=3"
                        alt="User avatar"
                    />
                </div>


                <div className="cfm-body">
                    <div className="cfm-user">
                        <div className="cfm-input-wrap">
                            <textarea
                                className="cfm-input"
                                placeholder="What is happing"
                                rows={4}
                            />
                        </div>
                    </div>
                    <div className="cfm-permissions">
                        <CreatePostPermissions
                            value={permission}
                            onChange={(val) => setPermission(val)}
                        />
                    </div>

                    <hr className="cfm-divider" />

                    <div className="cfm-footer">
                        <div className="cfm-actions">
                            <button className="cfm-icon-btn" data-tooltip="Image"><i class="fi fi-rr-picture"></i></button>
                            <button className="cfm-icon-btn" data-tooltip="Video"><i class="fi fi-rr-video-camera-alt"></i></button>
                            <button className="cfm-icon-btn" data-tooltip="GIF"><i class="fi fi-rr-gif"></i></button>
                            <button className="cfm-icon-btn" data-tooltip="Location"><i class="fi fi-rr-marker"></i></button>
                            <button className="cfm-icon-btn" data-tooltip="Poll"><i class="fi fi-rs-settings-sliders"></i></button>
                            <button className="cfm-icon-btn" data-tooltip="Emoji"><i class="fi fi-rr-smile"></i></button>
                            <button className="cfm-icon-btn" data-tooltip="Schedule"><i class="fi fi-rr-calendar-clock"></i></button>
                        </div>

                        <button className="cfm-share">Share Post</button>
                    </div>
                </div>
            </div>
        </div>
    );
}
